import React from 'react';
import Card from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import { useStudentPortal } from '../store/StudentPortalContext';

const getContactLabel = (type) => {
  if (!type) return 'Contact';
  const value = type.toLowerCase();
  if (value.includes('guardian')) return 'Guardian';
  if (value.includes('parent')) return 'Parent';
  if (value.includes('emergency')) return 'Emergency';
  if (value.includes('social')) return 'Social worker';
  return 'Contact';
};

export default function StudentPortalEmergencyPage() {
  const { student } = useStudentPortal();
  const contacts = student?.contacts || [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="sp-value" style={{ fontSize: '20px', fontWeight: 600 }}>Emergency Contacts</h2>
        <p className="sp-muted">People and services to contact if you need urgent help.</p>
      </div>

      <Card className="p-5 space-y-3">
        <div className="sp-alert sp-alert--critical text-sm">
          If you are in immediate danger or need urgent help, call emergency services (999).
        </div>
        {contacts.length === 0 ? (
          <p className="text-sm sp-muted">No emergency contacts recorded. Ask your centre team to update them.</p>
        ) : (
          <div className="space-y-3">
            {contacts.map((contact) => (
              <div key={contact.id || contact.name} className="sp-panel sp-panel--muted p-3 text-sm">
                <div className="flex items-center justify-between gap-2">
                  <div className="sp-value" style={{ fontWeight: 600 }}>{contact.name}</div>
                  <Badge variant="inactive">{getContactLabel(contact.type)}</Badge>
                </div>
                <div className="text-xs sp-muted">{contact.role || 'Contact'}</div>
                <div className="mt-2 space-y-1">
                  {contact.phone && <div>Phone: {contact.phone}</div>}
                  {contact.email && <div>Email: {contact.email}</div>}
                </div>
                {contact.notes && <div className="text-xs sp-muted mt-2">{contact.notes}</div>}
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
